import { action, makeAutoObservable, observable, toJS } from 'mobx';
import { getCountryData } from '../api/api';
import { getCookie, setCookie } from '../helpers';

class AppStore {
  constructor() {
    makeAutoObservable(this);
  }

  /**
   * Бренд ленда
   * @type {String}
   */
  @observable brandName = 'zenit';
  /**
   * Инициализация бренда
   */
  @action setBrandName = (brandName) => {
    this.brandName = brandName;
  };

  /**
   * Список доступных языков
   * @type {{}}
   */
  @observable CountryDataList = [];
  /**
   * Инициализация списка доступных языков
   */
  @action initCountryDataList = () =>
    getCountryData()
      .then((response) => (this.CountryDataList = response))
      .catch((err) => console.log('ошибка загрузки =', err));

  /**
   * Получить данные для реги (язык и страну) по названию языка
   * @param {String} [name='ru'] Код языка
   */
  @action getCountryDataByName = (name = 'ru') =>
    Object.values(toJS(this.CountryDataList)).find(
      (item) => item.code === (name === 'en' ? 'ca' : name).toUpperCase(),
    );

  /**
   * Список доступных языков, сгруппированные по названию лендинга и далее по брендам
   * @type {{}}
   */
  @observable landingsLangList = [];
  /**
   * Инициализация списка языков по лендингам
   */
  @action initLandingsLangList = (list) => {
    this.landingsLangList = list;
  };

  /**
   * Состояние загрузки страницы, true - загружается, false - загрузка завершена
   * @type {boolean}
   */
  @observable
  loading = true;

  /**
   * Установить состояние загрузки страницы
   * @param loading Состояние загрузки, true - загружается, false - загрузка завершена
   */

  @action
  setLoading = (loading) => {
    this.loading = loading;
  };

  /**
   * Достать куку языка с основного сайта
   * @type {string}
   */
  @observable
  langIdFromMainSite = getCookie('lang');

  /**
   * Установить отдельную куку для языка с основного сайта
   */
  @action
  setLangIdFromMainSite = () => {
    if (this.langIdFromMainSite) {
      setCookie('langIdFromMainSite', this.langIdFromMainSite);
    }
  };

  /**
   * Залогинен ли пользователь
   */
  @observable
  isUserLoggedIn = getCookie('user_logged_in');
}

const LandingAppStore = new AppStore();

export default LandingAppStore;
